/**
 * The MIT License (MIT)
 * https://github.com/aurelia/dependency-injection
 *
 * Copyright (c) 2010 - 2018 Blue Spire Inc.
 */
import 'reflect-metadata';
import constants from '../constants';
/**
 * Decorator: Specifies a custom registration strategy for the decorated class/function.
 */
export function Wrap(wrap) {
    return (target) => {
        if (Reflect.hasOwnMetadata(constants.wrap, target)) {
            const exitingWrap = Reflect.getOwnMetadata(constants.wrap, target);
            Reflect.defineMetadata(constants.wrap, {
                get(v, container, key) {
                    return wrap.get(exitingWrap.get(v, container, key), container, key);
                },
            }, target);
        }
        else {
            Reflect.defineMetadata(constants.wrap, wrap, target);
        }
    };
}
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoid3JhcC5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIndyYXAudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBQUE7Ozs7O0dBS0c7QUFDSCxPQUFPLGtCQUFrQixDQUFDO0FBQzFCLE9BQU8sU0FBUyxNQUFNLGNBQWMsQ0FBQztBQUdyQzs7R0FFRztBQUNILE1BQU0sVUFBVSxJQUFJLENBQUMsSUFBMkI7SUFDNUMsT0FBTyxDQUFDLE1BQVcsRUFBRSxFQUFFO1FBQ25CLElBQUksT0FBTyxDQUFDLGNBQWMsQ0FBQyxTQUFTLENBQUMsSUFBSSxFQUFFLE1BQU0sQ0FBQyxFQUFFO1lBQ2hELE1BQU0sV0FBVyxHQUEwQixPQUFPLENBQUMsY0FBYyxDQUM3RCxTQUFTLENBQUMsSUFBSSxFQUNkLE1BQU0sQ0FDVCxDQUFDO1lBQ0YsT0FBTyxDQUFDLGNBQWMsQ0FDbEIsU0FBUyxDQUFDLElBQUksRUFDZDtnQkFDSSxHQUFHLENBQUMsQ0FBQyxFQUFFLFNBQVMsRUFBRSxHQUFHO29CQUNqQixPQUFPLElBQUksQ0FBQyxHQUFHLENBQUMsV0FBVyxDQUFDLEdBQUcsQ0FBQyxDQUFDLEVBQUUsU0FBUyxFQUFFLEdBQUcsQ0FBQyxFQUFFLFNBQVMsRUFBRSxHQUFHLENBQUMsQ0FBQztnQkFDeEUsQ0FBQzthQUNxQixFQUMxQixNQUFNLENBQ1QsQ0FBQztTQUNMO2FBQU07WUFDSCxPQUFPLENBQUMsY0FBYyxDQUFDLFNBQVMsQ0FBQyxJQUFJLEVBQUUsSUFBSSxFQUFFLE1BQU0sQ0FBQyxDQUFDO1NBQ3hEO0lBQ0wsQ0FBQyxDQUFDO0FBQ04sQ0FBQyJ9